import { useState } from 'react';
import { Breadcrumb, Col, Container, Row } from 'react-bootstrap';
import { Link, Outlet } from 'react-router-dom';
import { ProfileProgress } from '../../../app/components/ProfileProgress';
import { TabsNavbar } from '../../../app/components/TabsNavbar';
import { useCurrentUser } from '../../../app/hooks/auth';
import { useDocumentTitle } from '../../../app/hooks/use-document-title';
import { useUserProgress } from '../../../app/hooks/user-progress';
import { VisibilityModal } from '../../Registration/VisibilityModal';
import { VisibilityModalContext } from '../../Registration/VisibilityModalContext';

export const CurrentProfileEdit = () => {
  useDocumentTitle('Edit Provider Profile');
  const [showVisibilityModal, setShowVisibilityModal] = useState(false);
  const { user } = useCurrentUser();
  const { progress, isProfileComplete, lastStep } = useUserProgress(
    user?.provider_completed_registration_steps
  );

  return (
    <div>
      <div className="bg-primary-dark">
        <Container className="pt-3 pb-1">
          <Breadcrumb className="breadcrumb-bg-primary-dark">
            <Breadcrumb.Item
              linkAs={Link}
              linkProps={{
                to: '/app/provider',
              }}
            >
              Your Profile
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Edit Profile</Breadcrumb.Item>
          </Breadcrumb>
        </Container>
      </div>
      <div className="bg-primary-dark">
        <Container className="page-header-title">
          <Row className="align-items-center">
            <Col>
              <h1>Edit Profile</h1>
            </Col>
            <Col xs="auto">{!isProfileComplete && <ProfileProgress progress={progress} />}</Col>
          </Row>
        </Container>
      </div>
      <div className="bg-primary-dark">
        <Container>
          <TabsNavbar
            alignment="center"
            variant="primary-dark"
            tabs={[
              {
                label: 'Basic Info',
                to: '/app/provider/edit',
              },
              {
                label: 'Rates',
                to: '/app/provider/edit/rates',
              },
              {
                label: 'Professional Traits',
                to: '/app/provider/edit/professional-traits',
              },
              {
                label: 'Identification',
                to: '/app/provider/edit/identification',
              },
              {
                label: 'Education',
                to: '/app/provider/edit/education',
              },
              {
                label: 'Licenses',
                to: '/app/provider/edit/licenses',
              },
              {
                label: 'Other',
                to: '/app/provider/edit/other',
              },
            ]}
          />
        </Container>
      </div>
      <Container className="my-4">
        <VisibilityModalContext.Provider value={{ showVisibilityModal, setShowVisibilityModal }}>
          <Outlet />
        </VisibilityModalContext.Provider>
      </Container>
      <VisibilityModal show={showVisibilityModal} onHide={() => setShowVisibilityModal(false)} />
    </div>
  );
};
